var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.$store.state.message.text)?_c('p',{style:({color: _vm.$store.state.message.color})},[_vm._v("\n    "+_vm._s(_vm.$store.state.message.text)+"\n    ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }